import t from"react";import{mdiMessageText as e}from"@mdi/js";import{MdIcon as m}from"./MdIcon.js";const o=({id:o="message-text",title:r="Message",...i})=>t.createElement(m,{id:o,title:r,path:e,...i});export{o as MessageTextIcon};
